<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8229 13.8422C11.8865 13.9058 11.9056 14.0015 11.8711 14.0846C11.8367 14.1678 11.7556 14.222 11.6656 14.222C11.5756 14.222 11.4945 14.1678 11.4601 14.0846C11.4256 14.0015 11.4447 13.9058 11.5083 13.8422C11.5953 13.7555 11.7359 13.7555 11.8229 13.8422"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.8325 19.8356H4.66243C4.04328 19.8358 3.44944 19.5899 3.01164 19.1521C2.57384 18.7143 2.32795 18.1204 2.32813 17.5013V10.4984C2.32795 9.87922 2.57384 9.28538 3.01164 8.84758C3.44944 8.40977 4.04328 8.16389 4.66243 8.16406H12.8325"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.15495 13.8422C7.21858 13.9058 7.23761 14.0015 7.20318 14.0846C7.16874 14.1678 7.08762 14.222 6.99764 14.222C6.90766 14.222 6.82654 14.1678 6.7921 14.0846C6.75767 14.0015 6.7767 13.9058 6.84033 13.8422C6.9273 13.7555 7.06798 13.7555 7.15495 13.8422"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="16.334"
      y="12.249"
      width="9.33722"
      height="7.58649"
      rx="1.65"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.1191 12.2493V9.88063C18.1191 8.28808 19.4102 6.99707 21.0027 6.99707V6.99707C21.7675 6.99707 22.5009 7.30087 23.0417 7.84164C23.5824 8.38242 23.8863 9.11586 23.8863 9.88063V9.88063V12.269"
      :stroke="clr ? clr : '#500FE9'"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
